import { CreateWorkorderLineRequest, IWorkorder, UpdateWorkorderLineRequest } from '@cbgms/api/modules/workorder'
import { WorkorderLineStatus } from '@cbgms/api/modules/enums'

export const getOrderWithRelated = (orderUUID: string) => ({
  method: 'GET',
  url: `/modules/workorders/${orderUUID}/with-related`
})

export const getOrderLines = (orderUUID: string) => ({
  method: 'GET',
  url: `/modules/workorders/${orderUUID}/lines`
})

export const getChangedOrderLines = (orderUUID: string) => ({
  method: 'GET',
  url: `/modules/workorders/${orderUUID}/parts-info-difference`
})

export const putOrder = (orderUUID: string, data: Partial<IWorkorder>) => ({
  method: 'PUT',
  url: `/modules/workorders/${orderUUID}`,
  data
})

export const putOrderLine = (orderUUID: string, lineUUID: string, data: UpdateWorkorderLineRequest) => ({
  method: 'PUT',
  url: `/modules/workorders/${orderUUID}/lines/${lineUUID}`,
  data
})

export const postOrderLine = (orderUUID: string, data: CreateWorkorderLineRequest) => ({
  method: 'POST',
  url: `/modules/workorders/${orderUUID}/lines`,
  data
})

export const deleteOrderLine = (orderUUID: string, lineUUID: string) => ({
  method: 'DELETE',
  url: `/modules/workorders/${orderUUID}/lines/${lineUUID}`
})

export const deleteAllOrderLines = (orderUUID: string) => ({
  method: 'DELETE',
  url: `/modules/workorders/${orderUUID}/lines`
})

export const rectifyOrder = (orderUUID: string) => ({
  method: 'PUT',
  url: `/modules/workorders/${orderUUID}/parts-info-difference/rectify`
})

export const setOrderStatus = (orderUUID: string, orderStatus: WorkorderLineStatus) => ({
  method: 'PUT',
  url: `/modules/workorders/${orderUUID}/order-status/${orderStatus}`
})
